const InvoicingSetup = {
  SingleInvoicing: "single-invoicing",
};

export default InvoicingSetup;
